import React, {Fragment} from "react";
import Helmet from "react-helmet";
import {useSelector} from "react-redux";
import CustomSnackbarProvider from "./hocs/snackbar-provider";
import HubRouter from "./routers/HubRouter";
import {languageSelector} from "./state/app/appSelectors";

const App = () => {
  const language = useSelector(languageSelector);

  return (
    <Fragment>
      <Helmet>
        <html lang={language} />
      </Helmet>
      <CustomSnackbarProvider>
        <HubRouter />
      </CustomSnackbarProvider>
    </Fragment>
  );
};

export default App;
